import React, { useEffect } from 'react';

import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { useRevocation } from '../../providers/RevocationContext';
import Log from '../../common/logging';
import { Routes } from '../../config/routes';
import { useNavigate } from 'react-router-dom';
import { UserResponseOptions, ServiceErrorType } from '../../services/common/serviceError';
import ServiceErrorProvider from '../../services/common/serviceErrorProvider';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import { MatchStatus } from '../../services/faceAuthentication/facetec/facetecProcessor';

function RevocationInReviewScreen(): JSX.Element {
  const { revokePasses, selectedRevocationPasses } = useRevocation();
  const navigate = useNavigate();

  const revoke = async () => {
    try {
      await revokePasses();
      navigate(Routes.REVOCATION_SUCCESS);
    } catch (e) {
      const notifyUserOptions = UserResponseOptions.fail;
      await ServiceErrorProvider.notifyUser(ServiceErrorType.network, notifyUserOptions);
      navigate(Routes.REVOCATION);
      const error = e as Error;
      Log.error(error.message);
    }
  };

  useEffect(() => {
    revoke();
  }, []);

  const hasActivePasses = selectedRevocationPasses.some((pass) => pass.status === MatchStatus.ACTIVE);

  return (
    <MessagePanel
      title="screens.revocationInReview.title"
      description={
        hasActivePasses ? 'screens.revocationInReview.description' : 'screens.revocationInReview.descriptionNoToken'
      }
      showLoading
      showSupportLink
    />
  );
}
export default withRouteAnalytics(RevocationInReviewScreen, Screens.REVOCATION_IN_REVIEW);
